export const REQUEST_MESSAGEABLE_NAMES = "REQUEST_MESSAGEABLE_NAMES";
export const RECEIVE_MESSAGEABLE_NAMES = "RECEIVE_MESSAGEABLE_NAMES";
export const DEBOUNCED_UPDATE_PRODUCT = "DEBOUNCED_UPDATE_PRODUCT";
export const SEARCH_MESSAGEABLE_NAMES = "SEARCH_MESSAGEABLE_NAMES";
